export default __webpack_public_path__ + "static/bcos-plugin-92ec5995fb369775395ea39477ca075e.png";